import { createSlice } from "@reduxjs/toolkit";
import { createCustomAsyncThunk, defaultEntityAdapter } from "../utils";
import { dictService } from "../../services/dictService";

export const getStudios = createCustomAsyncThunk(
    "dicts/studios/get",
    async params => await dictService.getStudios(params)
)

const studiosSlice = createSlice({
    name: "dicts/studios",
    initialState: defaultEntityAdapter.getInitialState({
        isLoading: false,
        error: null
    }),
    extraReducers: builder => {
        builder
            .addCase(getStudios.pending, state => { state.isLoading = true })
            .addCase(getStudios.fulfilled, (state, action) => {
                defaultEntityAdapter.setAll(state, action.payload)
                state.isLoading = false
            })
            .addCase(getStudios.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error
            })
    }
})

export const studioSelectors = defaultEntityAdapter.getSelectors(x => x.dicts.studios)

export default studiosSlice.reducer